export const staticStrings = {
    rates24: 'Rates to start soon',
}